import { useState } from 'react';
import { useData } from '@yingbaba/api';
import type { Portfolio } from '@yingbaba/types';
import { Button, Modal, PortfolioShowcase, QueryState, TagList, Status } from '@yingbaba/ui';

export function PortfolioReview({ id }: { id: string }) {
  const [open, setOpen] = useState(false);
  const query = useData<Portfolio>(`/admin/cases/${id}/detail`, open);
  return (
    <>
      <Button variant="secondary" size="sm" onClick={() => setOpen(true)}>
        预览完整作品
      </Button>
      <Modal
        open={open}
        onOpenChange={setOpen}
        title="案例作品审核"
        description="检查实际作品内容、公开展示授权与制作署名，确认后再通过审核。"
      >
        <QueryState query={query}>
          {query.data && (
            <div className="stack">
              <div className="row spread wrap">
                <h3>{query.data.title}</h3>
                <Status value={query.data.status} />
              </div>
              <p className="muted small">
                {query.data.category} · {query.data.industry} ·{' '}
                {query.data.provider_name || '制作团队'}
              </p>
              <PortfolioShowcase key={query.data.updated_at} item={query.data} scope="admin" />
              <TagList value={query.data.tags} />
              <h3>创作说明</h3>
              <p className="prose">{query.data.description}</p>
              {!!query.data.credits?.length && (
                <>
                  <h3>制作署名</h3>
                  <div className="row wrap">
                    {query.data.credits.map((credit) => (
                      <span className="tag" key={credit.id}>
                        {credit.role} · {credit.display_name}
                        {credit.verified ? ' · 已核验' : ''}
                      </span>
                    ))}
                  </div>
                </>
              )}
            </div>
          )}
        </QueryState>
      </Modal>
    </>
  );
}
